import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { Link } from "react-router-dom";
import BASE_URL  from "api/Api";
import { FaHome, FaPlus, FaEdit, FaTrash, FaCalendarAlt, FaImage } from "react-icons/fa";
import "assets/theme/admin_list.css";

const HeroSectionList = () => {
  const [heroes, setHeroes] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHeroes = async () => {
    try {
      const res = await apiFetch("leader_admin/get_hero_section");
      setHeroes(res.data || []);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHeroes();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this hero section?"))
      return;

    try {
      await apiFetch(`leader_admin/delete_hero_section/${id}`, {
        method: "DELETE",
      });
      fetchHeroes();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-3">
        {/* Header Card */}
        <div className="admin-header-card mb-4">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 position-relative" style={{ zIndex: 1 }}>
            <div className="d-flex align-items-center gap-3">
              <div className="admin-header-icon-box">
                <FaHome />
              </div>
              <div>
                <h4 className="text-white fw-bold mb-1" style={{ fontSize: "1.3rem" }}>
                  मुख्य बॅनर यादी / Hero Section Banners
                </h4>
                <p className="text-white-50 mb-0" style={{ fontSize: "0.88rem" }}>
                  Manage homepage banners and carousel hero items
                </p>
              </div>
            </div>

            <Link to="/add_hero_section" className="btn btn-admin-add">
              <FaPlus /> <span>Add New Hero / नवीन बॅनर</span>
            </Link>
          </div>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          <div className="card-body p-0">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-warning" role="status"></div>
                <p className="text-muted mt-2 fw-semibold mb-0">माहिती लोड होत आहे...</p>
              </div>
            ) : heroes.length === 0 ? (
              <div className="text-center py-5">
                <FaImage className="text-muted mb-3" style={{ fontSize: "2.5rem", opacity: 0.4 }} />
                <h6 className="text-muted fw-bold">No Hero Banners Found</h6>
                <p className="text-muted small mb-0">No homepage hero banners have been added yet.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-admin-custom align-middle">
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }}>Sr. No.</th>
                      <th style={{ width: "120px" }}>Image / बॅनर</th>
                      <th>Title / शीर्षक</th>
                      <th>Description / वर्णन</th>
                      <th>Created Date / दिनांक</th>
                      <th className="text-center" style={{ width: "120px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {heroes.map((hero, index) => (
                      <tr key={hero.hero_section_id}>
                        <td>
                          <span className="fw-semibold text-muted">{(index + 1).toString().padStart(2, "0")}</span>
                        </td>

                        <td>
                          {hero.image_url ? (
                            <img
                              src={`${BASE_URL}/${hero.image_url}`}
                              alt="Hero"
                              className="rounded-3 shadow-sm border"
                              style={{
                                width: "90px",
                                height: "55px",
                                objectFit: "cover",
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.style.display = "none";
                              }}
                            />
                          ) : (
                            <span className="badge bg-secondary bg-opacity-10 text-secondary fw-normal">No Image</span>
                          )}
                        </td>

                        <td>
                          <span className="fw-bold text-dark">{hero.title}</span>
                        </td>

                        <td style={{ maxWidth: "280px" }}>
                          <div className="small text-muted text-truncate">
                            {hero.description}
                          </div>
                        </td>

                        <td>
                          <small className="text-muted">
                            <FaCalendarAlt className="me-1" />
                            {new Date(hero.created_at).toLocaleDateString("en-IN")}
                          </small>
                        </td>

                        <td>
                          <div className="d-flex justify-content-center gap-2">
                            <Link
                              to={`/edit_hero_section/${hero.hero_section_id}`}
                              className="btn-action-icon edit"
                              title="Edit Banner"
                            >
                              <FaEdit />
                            </Link>

                            <button
                              onClick={() => handleDelete(hero.hero_section_id)}
                              className="btn-action-icon delete"
                              title="Delete Banner"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default HeroSectionList;